// constante utilizada para manejar los mensajes desde el Frontend
export const regExp = {
    url: '^[\\w\\-]+(\\.[\\w\\-]+)+[/#?]?.*$',
    urlHttps: '^(?:http(s)?:\\/\\/)[\\w\\-]+(\\.[\\w\\-]+)+[/#?]?.*$',
    NN: 'NN',
    endLine: '\n'//'\r\n+|\r+|\n+|\t+'
  };
